import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { Device } from '@sss/sdk';
import { sdk } from '../../lib/sdk';

export default function DevicesTab() {
  const { t } = useTranslation();
  const [devices, setDevices] = useState<Device[] | null>(null);
  const [busyId, setBusyId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    try {
      setDevices(await sdk.devices.list());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed');
    }
  }

  useEffect(() => {
    load();
  }, []);

  async function onRemove(id: string) {
    setError(null);
    setBusyId(id);
    try {
      await sdk.devices.delete(id);
      await load();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed');
    } finally {
      setBusyId(null);
    }
  }

  if (!devices && !error) return <p>{t('common.loading')}</p>;

  return (
    <section>
      <h3>{t('settings.devices.title')}</h3>
      <p style={{ color: '#666' }}>{t('settings.devices.description')}</p>

      {devices && devices.length === 0 ? (
        <p style={{ color: '#888' }}>{t('settings.devices.empty')}</p>
      ) : (
        <ul style={list}>
          {devices?.map((d) => (
            <li key={d.id} style={row}>
              <div>
                <strong>{d.deviceType}</strong>
                <div style={{ color: '#666', fontSize: '0.85rem' }}>
                  {t('settings.devices.lastActive')}: {new Date(d.lastActive).toLocaleString()}
                  {' · '}
                  {t('settings.devices.status')}: {d.status}
                </div>
              </div>
              <button onClick={() => onRemove(d.id)} disabled={busyId === d.id} style={btn}>
                {busyId === d.id ? t('common.loading') : t('settings.devices.remove')}
              </button>
            </li>
          ))}
        </ul>
      )}

      {error && <p style={{ color: 'red' }}>{error}</p>}
    </section>
  );
}

const list: React.CSSProperties = { listStyle: 'none', padding: 0, display: 'flex', flexDirection: 'column', gap: '0.75rem' };
const row: React.CSSProperties = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0.75rem', border: '1px solid #ddd', borderRadius: 4 };
const btn: React.CSSProperties = { padding: '0.5rem 1rem', cursor: 'pointer' };
